import React from "react";
import {Flex} from "antd";
import {PublicEventDTO} from "../../home/types";
import {SmallEventCard} from "./small-event-card";

export const EventCollectionDisplay: React.FC<{events: PublicEventDTO[]}> = ({events}) => {
    return (
        <Flex wrap={"wrap"} align={"start"} justify={"start"} >
            {events.map((event) =>
                <SmallEventCard key={event.id} event={event} />
            )}
        </Flex>
    )
}
